<template>
<div class="view" v-if="hasPermissions(['Daily-Assignment Write'])">
    <Breadcrumb :breadcrumb="breadcrumb" />
    <h1 class="view__title title--1" v-html="title_page" />

    <div class="row ml-0">
        <h6 class="view__title title--1" style="font-size: 13px; font-weight: initial; color: gray;">
            <span>
                <img src="/assets/img/svg/information.svg" style="width:15px;" alt="info">
            </span>
            <span v-html="'Use this section to search for assignments.'" style="margin-left:5px;" />
        </h6>
    </div>
    <DailyAssignmentsAdvancedSearch ref="advanced_search" :checkeable="true" :rest_api="rest_api" :rest_api_pagination="rest_api_pagination" @passInitialData="getInitialData($event)" />
    <hr />
    <div class="row mb-0 ml-0">
        <div style="font-size: 13px; font-weight: initial; color: gray; margin-top: 30px;">
            <span>
                <img src="/assets/img/svg/information.svg" style="width:15px;" alt="info">
            </span>
            <span v-html="'Use this section to make changes.'" style="margin-left:5px;" />
        </div>
    </div>
    <form @submit.prevent="form_submit()">
        <FormDynamic :form_format="form_format" :form_data="form_data" :array_options="array_options" :for_update="false" :content_align_x="'no-justify'" />
        <div class="row mb-0 assignments">
            <div class="col-md-12">
                <div class="text-md-left mt-lg-3">
                    <CentralLiteButtons :not_show_cancel="true" :type="''" :save_text="'Save changes'" />
                </div>
            </div>
        </div>
    </form>
    <FieldsConfirmationModal :title="'Fields confirmation'" :breadcrumb="breadcrumb" :form_data="form_data" :notyf="notyf" @formSubmit="form_submit(true)" ref="fields_confirmation_modal" />
    <WaitingModal />
</div>
</template>

<script>
import Methods from './methods'
import { Notyf } from 'notyf'
import Resources from './resources'
import FormResources from './form_resources'
import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import CentralLiteButtons from '@/components/CentralLiteButtons'
import WaitingModal from '@/components/WaitingModal'
import DailyAssignmentsAdvancedSearch from '../AdvancedSearch/DailyAssignmentsAdvancedSearch'
import FieldsConfirmationModal from './FieldsConfirmationModal'
import FormDynamic from '@/components/FormDynamic.vue'
import 'notyf/notyf.min.css' // for React and Vue
const notyf = new Notyf({
    duration: 8000,
})

export default {
    name: 'MassEditDailyAssignments',
    components: {
        Breadcrumb,
        WaitingModal,
        DailyAssignmentsAdvancedSearch,
        FormDynamic,
        CentralLiteButtons,
        FieldsConfirmationModal,
    },

    mixins: [
        Methods,
    ],

    data() {
        return {
            notyf,
            title_page: 'Daily Assignments - Mass Edit',
            rest_api: `daily_assignments`,
            rest_api_pagination: `daily_assignments_pagination`,
            child_href: '/assignment-daily-assignments/',
            table_headers: Resources.table_headers,
            breadcrumb: Resources.breadcrumb,
            form_format: FormResources.form_format,
            form_data: FormResources.form_data,
            form_backup: { ...FormResources.form_data },
            select_all: false,
            rooms: [],
            array_options: {},
            search: '',
            summary: []
        }
    },

}
</script>
